import dayjs from "dayjs"
import duration from 'dayjs/plugin/duration'
import { isEmpty } from "lodash"
dayjs.extend(duration)


export const getTime = (seconds: number): string => {
  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = Math.round(seconds % 60);

  if (hrs > 0) {
    // show hours if more than 60 min
    return `${hrs.toString().padStart(2, '0')}:${mins
      .toString()
      .padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  }

  // otherwise just mm:ss
  return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
};


export const startTimeFrom0 = (time: number[]): number[] => {
  if (isEmpty(time)) return []
  let length = time[time.length - 1] - time[0]
  let arr: number[] = [0]
  while (arr[arr.length - 1] < length) {
    arr.push(arr[arr.length - 1] + 1)
  }
  return arr
}
export const mergeArr = (xArr: number[], yArr: number[]) => {
  return xArr.map((item, index) => [item, yArr[index]])
}